// #region imports

// --- Angular
import { Injectable } from '@angular/core';

// --- RxJs
import { Observable, BehaviorSubject } from 'rxjs';

// --- HS Code
import { QuestionModel, QuestionTypes } from '../../../models';

// #endregion

@Injectable({
  providedIn: 'root'
})
export abstract class QuestionsBaseService {
  protected _questions$: BehaviorSubject<QuestionModel[]>;
  get questions$(): Observable<QuestionModel[]> {
    return this._questions$;
  }

  protected _indicatorQuestions$: BehaviorSubject<QuestionModel[]>;
  get indicatorQuestions$(): Observable<QuestionModel[]> {
    return this._indicatorQuestions$;
  }

  protected _effectivenessQuestions$: BehaviorSubject<QuestionModel[]>;
  get effectivenessQuestions$(): Observable<QuestionModel[]> {
    return this._effectivenessQuestions$;
  }

  protected _questionGroups$: BehaviorSubject<QuestionModel[][]>;
  get questionGroups$(): Observable<QuestionModel[][]> {
    return this._questionGroups$;
  }

  constructor() {
    this._questions$ = new BehaviorSubject<QuestionModel[]>(null);
    this._indicatorQuestions$ = new BehaviorSubject<QuestionModel[]>(null);
    this._effectivenessQuestions$ = new BehaviorSubject<QuestionModel[]>(null);
    this._questionGroups$ = new BehaviorSubject<QuestionModel[][]>(null);
  }

  abstract loadQuestions(): void;

  protected initialiseQuestions(questions: QuestionModel[]): void {
    const indicatorQuestions = questions.filter(q => {
      return q.questionType === QuestionTypes.indicator;
    });

    const effectivenessQuestions = questions.filter(q => {
      return q.questionType === QuestionTypes.effectiveness;
    });

    const questionGroups = new Array<QuestionModel[]>();
    for (let i = 0; i < indicatorQuestions.length; i += 15) {
      questionGroups[
        (i / 15 + 1).toString()
      ] = indicatorQuestions.slice(i, i + 15);
    }

    this._questions$.next(questions);
    this._indicatorQuestions$.next(indicatorQuestions);
    this._effectivenessQuestions$.next(effectivenessQuestions);
    this._questionGroups$.next(questionGroups);
  }
}
